import SalesExpensesMSTEditPage from './SalesSuppliersMSTEditPage';

export default SalesExpensesMSTEditPage;
